import React, {useEffect, useState} from "react";
import { MenuFoldOutlined } from "@ant-design/icons";
import "../../style/global.css"
import Ronaldo from "@assets/images/default.webp";
import { useIsMood } from "../store/selector";
import SearchForm from "@components/Input/SearchForm/SearchForm";
import HeaderIcons from "../components/HeaderIcons/HeaderIcons";
import Bottom from "@assets/icon/union.svg";
import AccountSettings from "../../pages/AccountSettings/container";
import { FullNameTitle } from "../../styled";
import { ReactComponent as BurgerIcon } from '@assets/icon/burger.svg';
import { ReactComponent as MobileLogo } from '@assets/icon/logoMobile.svg';

import {
  HeaderContainer, HeaderIconHover,
  HeaderSearchButtonWrapper, HeaderUserFullNameWrapper,
  HeaderUserInformationWrapper, HeaderUserPosition, HeaderUserSettingContainer,
  HeaderUserWrapper,
  InputIconWrapper, MbOpenClick, UserImageWrapper
} from "../styled";
import ButtonIcon from "@components/Buttons/ButtonIcon/ButtonIcon";
import {IHeaderProps} from "../types";


const Header = ({ setIsCollapsed }: IHeaderProps) => {
  const isMood = useIsMood();
  const name = localStorage.getItem("name");
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 575);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 575);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const role = localStorage.getItem("user_role");
  return (
    <HeaderContainer isMood={isMood}>
      <InputIconWrapper>
        <ButtonIcon
          type="text"
          icon={<MenuFoldOutlined />}
          onClick={() => setIsCollapsed((isPrev) => !isPrev)}
          isMood={isMood}
          className="Mb_btn"
        />
        <MbOpenClick>
          <div style={{padding:0,marginTop:10}} onClick={() => setIsCollapsed((isPrev) => !isPrev)}>
            <BurgerIcon />
          </div>
        </MbOpenClick>
        <HeaderSearchButtonWrapper>
          <SearchForm />
        </HeaderSearchButtonWrapper>
        <div style={{marginTop:"12.5px"}}>
          {isMobile && <MobileLogo />}
        </div>
      </InputIconWrapper>
      <HeaderUserInformationWrapper>
        <HeaderIcons isMobile={isMobile} />

        <HeaderUserWrapper>
          <HeaderUserFullNameWrapper>
            <FullNameTitle> {name} </FullNameTitle>
            <HeaderUserPosition align="left">{role}</HeaderUserPosition>
          </HeaderUserFullNameWrapper>

          <UserImageWrapper src={Ronaldo} alt="User Image" />
          <HeaderUserSettingContainer>
            <HeaderIconHover  src={Bottom} />
            <AccountSettings />
          </HeaderUserSettingContainer>
        </HeaderUserWrapper>
      </HeaderUserInformationWrapper>
    </HeaderContainer>
  );
};

export default Header;
